import { Component } from '@angular/core';
import { AppConfigService } from './../../../../core/services/app-config.service';


/**
 * Componente con la leyenda de colores.
 *
 * @author aarodriguezo
 *
 * @version 01.02.0400
 * @since 01.02.0000
 */
@Component({
  selector: 'app-home-delivery',
  templateUrl: './home-delivery.component.html',
  styleUrls: ['../../dispositivos.component.css', './home-delivery.component.css']
})
export class HomeDeliveryComponent {
  constructor() {}


  public abrirURLinfo(){
    window.open(AppConfigService.urlInfoHomeDelivery);
  }
}
